module.exports = "../dist/img/product-detail-1-32.16c1.jpg";